'use strict';

const openModal = require('App/services/Modal').default;

angular.module('upDirectives').directive('upTable2', [
	'AppService',
	'FilterHelper',
	'ListViewService',
	'$translate',
	'$multiSelect',
	'$upModal',
	'avatarService',
	'$rootScope',
	'$parse',
	'$filter',
	'browserService',
	'URL',
	'API',
	'$state',
	'VoiceService',
	'FeatureHelper',
	'NotificationService',
	function (
		AppService,
		FilterHelper,
		ListViewService,
		$translate,
		$multiSelect,
		$upModal,
		avatarService,
		$rootScope,
		$parse,
		$filter,
		browserService,
		URL,
		API,
		$state,
		VoiceService,
		FeatureHelper,
		NotificationService
	) {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				// We do not need all of this i think
				tableData: '=',
				tableColumns: '=',
				tableLoading: '=',
				tableOptions: '=',
				tableTemplate: '=',
				tableTemplateComponent: '=',
				tableType: '@',
				tableClick: '&',
				tableLimit: '=',
				pages: '=',
				offset: '=',
				actions: '=',
				sorting: '=',
				customFields: '=customfields',
				onSort: '&',
				tableInactive: '=',
				editColumns: '&',
				selectables: '=',
				maxColumns: '=',
				getAccountExtra: '&'
			},
			templateUrl: require('App/upsales/common/directives/templates/upTable2.tpl.html?file'),
			controller: [
				'$scope',
				function ($scope) {
					this.selectables = [];

					this.setTableSticky = function (sticky) {
						$scope.tableSticky = sticky !== undefined;
					};

					this.setTableEditable = function (editable) {
						$scope.tableEditable = editable !== undefined;
					};

					this.sort = function ($sorting) {
						$scope.tableLoading = true;
						$scope.sorting = [$sorting];

						if ($scope.onSort && typeof $scope.onSort === 'function') {
							$scope.onSort();
						}

						$scope.$apply();
					};

					this.onError = function () {
						$scope.tableError = true;
						$scope.tableLoading = false;
					};
				}
			],
			link: function ($scope, table, attrs, controller) {
				let tableElement;
				var columnTemplates = ListViewService.getAttrs(attrs.tableType);

				var reRender = function () {
					setTimeout(function () {
						renderTable($scope.tableData, $scope.tableColumns);
					}, 0);
				};

				$scope.$on('$multiSelect.toggle', reRender);
				$scope.$on('$multiSelect.selectAll', reRender);
				$scope.$on('$multiSelect.selectAllFilter', reRender);
				$scope.$on('$multiSelect.selectNone', reRender);

				var columns = ListViewService.getAttrs(attrs.tableType);
				var categoryTypes = AppService.getCategoryTypes(attrs.tableType);

				if (attrs.tableType.indexOf('userDefinedObject') === 0) {
					categoryTypes = AppService.getCategoryTypes(
						'userDefined' + attrs.tableType[attrs.tableType.length - 1]
					);
				} else {
					categoryTypes = AppService.getCategoryTypes(attrs.tableType);
				}

				angular.forEach(columns, function (attr, key) {
					if (attr.selectableColumn) {
						attr.key = key;
						controller.selectables.push(attr);
					}
				});

				// Add customCategory types to selection
				if (categoryTypes.length) {
					angular.forEach(categoryTypes, function (cat) {
						controller.selectables.push({
							field: 'Category_' + cat.id,
							key: 'Category_' + cat.id,
							title: cat.name
						});
					});
				}

				// Add extra selectables
				if ($scope.selectables) {
					angular.forEach($scope.selectables, function (sel) {
						controller.selectables.push({
							field: sel.key,
							key: sel.key,
							title: sel.title
						});
					});
				}

				controller.selectables = _.uniq(controller.selectables, 'field');

				var clientStandardFields = Tools.AppService.getMetadata().standardFields.Client;
				controller.selectables = _.each(controller.selectables, function (field) {
					if (attrs.tableType === 'account') {
						_.each(clientStandardFields, function (s) {
							if (s.column === field.field && s.canHide === true && s.active === false) {
								field.hide = true;
							}
						});
					}
				});

				var editColumns = function () {
					if (attrs.editColumns && typeof $scope.editColumns === 'function') {
						$scope.editColumns({ $tableType: attrs.tableType });
					} else {
						openModal('EditColumnsModal', {
							columns: $scope.tableColumns,
							selectables: controller.selectables,
							customfields: $scope.customFields,
							tableType: attrs.tableType,
							maxColumns: $scope.maxColumns || 8,
							onClose: function (columns) {
								if (!columns) return;
								$scope.tableColumns = columns;
								setTimeout(() => {
									// eslint-disable-line no-undef
									$scope.getAccountExtra();
									$scope.$apply();
								}, 0);
							}
						});
					}
				};

				var renderTimeout;
				function renderTable(rows, cols) {
					if (!tableElement) {
						tableElement = table.find('#table-container')[0];
					}

					if (rows && Array.isArray(rows) && !$scope.tableInactive) {
						if (renderTimeout) {
							clearTimeout(renderTimeout);
						}
						renderTimeout = setTimeout(function () {
							if (!tableElement) {
								return;
							}

							_getOrCreateRoot(tableElement).render(
								React.createElement(ReactTemplates.table3, {
									// Table data and columns
									data: rows,
									columns: cols,
									columnTemplates: columnTemplates,
									currentSorting:
										Array.isArray($scope.sorting) && $scope.sorting.length
											? $scope.sorting[0]
											: null,
									template: $scope.tableTemplate,
									templateComponent: $scope.tableTemplateComponent,
									categoryTypes: categoryTypes,
									attrs: columns,
									sticky: $scope.tableSticky,
									loading: $scope.tableLoading,
									actions: $scope.actions,
									// Injects
									tools: {
										sort: controller.sort,
										limit: $scope.tableLimit,
										AppService: AppService,
										FilterHelper: FilterHelper,
										ListViewService: ListViewService,
										$translate: $translate.instant,
										customFields: $scope.customFields,
										$multiSelect: $multiSelect,
										metadata: AppService.getMetadata(),
										$upModal: $upModal,
										avatarService: avatarService,
										$rootScope: $rootScope,
										editColumns: editColumns,
										$filter: $filter,
										isIE: browserService.isIE(),
										URL: URL,
										API: API,
										$state: $state,
										$parse: $parse,
										VoiceService: VoiceService,
										FeatureHelper: FeatureHelper,
										NotificationService: NotificationService,

										// Opts, the ctrl can pass stuff here
										opts: $scope.tableOptions,

										// This is triggered when the array is changed in react
										onChange: function (newVal) {
											angular.copy(newVal, $scope.tableData);
										}
									}
								})
							);
						}, 10);
					}
				}

				// set table editable
				controller.setTableEditable(attrs.tableEditable);

				// Set sticky
				controller.setTableSticky(attrs.tableSticky);

				$scope.$watch('tableColumns', function (newValue, oldValue) {
					if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
						renderTable($scope.tableData, newValue);
					}
				});

				// Force a render of the react table
				$scope.$on('renderTable', function () {
					renderTable($scope.tableData, $scope.tableColumns);
				});

				$scope.$on('$destroy', function () {
					_unmountRoot(tableElement);
					tableElement = undefined;
				});

				$scope.$watch('tableInactive', function (inactive) {
					if (inactive) {
						table.hide();
					} else {
						table.show();
					}
				});

				$scope.$watch('tableLoading', function () {
					renderTable($scope.tableData, $scope.tableColumns);
				});

				$scope.$watchCollection('tableData', function (newValue) {
					renderTable(newValue, $scope.tableColumns);
				});
			}
		};
	}
]);
